import React, { useEffect, useState } from "react";
import Layout from "../components/layout/Layout";
// import check from "../../assests/HPE/Form/circle-check.png";
import check from "../assests/HPE/Form/circle-check.svg";
import book from "../assests/HPE/Form/mockup.webp";
import Button from "../components/common/Button";
import download from "../assests/HPE/Landing-page/hpe-cloud/icon-document.svg";
import thumbnail from "../assests/HPE/zerto/s_main-asset.webp";
import thumbnail_1 from "../assests/HPE/zerto/d_sol-img-1.webp";
import thumbnail_2 from "../assests/HPE/zerto/d_sol-img-2.webp";
import thumbnail_3 from "../assests/HPE/zerto/d_sol-img-3.webp";
import thumbnail_4 from "../assests/HPE/zerto/d_sol-img-4.webp";
import thumbnail_5 from "../assests/HPE/zerto/d_sol-img-5.webp";
import thumbnail_6 from "../assests/HPE/zerto/d_sol-img-6.webp";
import thumbnail_7 from "../assests/HPE/zerto/d_cus-img-1.webp";
import thumbnail_8 from "../assests/HPE/zerto/d_cus-img-2.webp";
import thumbnail_9 from "../assests/HPE/zerto/d_ebook-img.webp";
import { Download, FileDown } from "lucide-react";
import ZertoLayout from "../components/layout/ZertoLayout";

const sectionsData = [
  {
    id: 1,
    sectionTitle: "Solution briefs",
    items: [
      {
        id: 1,
        title: "Solution brief",
        description: "HPE Zerto Software - Less data loss, less downtime",
        thumbnail: thumbnail_1,
        buttonText: "Download pdf",
        pdf: "/pdfs/zerto/HPE Zerto Software – Less data loss, less downtime.pdf",
      },
      {
        id: 2,
        title: "Solution brief",
        description: "HPE Zerto Software for Amazon Web Services (AWS)",
        thumbnail: thumbnail_2,
        buttonText: "Download pdf",
        pdf: "/pdfs/zerto/HPE-Zerto-Software-for-Amazon-Web-Services-AWS.pdf",
      },
      {
        id: 3,
        title: "Solution brief",
        description: "HPE Zerto Software for Microsoft Azure",
        thumbnail: thumbnail_3,
        buttonText: "Download pdf",
        pdf: "/pdfs/zerto/HPE ZERTO SOFTWARE FOR MICROSOFT AZURE.pdf",
      },
      {
        id: 4,
        title: "Solution brief",
        description: "Why HPE Zerto Software for Ransomware Resilience",
        thumbnail: thumbnail_4,
        buttonText: "Download pdf",
        pdf: "/pdfs/zerto/Why HPE Zerto Software for Ransomware Resilience.pdf",
      },
      {
        id: 5,
        title: "Solution brief",
        description: "Workload Mobility with HPE Zerto Software",
        thumbnail: thumbnail_5,
        buttonText: "Download pdf",
        pdf: "/pdfs/zerto/WORKLOAD MOBILITY WITH HPE ZERTO SOFTWARE.pdf",
      },
      {
        id: 6,
        title: "Solution brief",
        description: "HPE Zerto Software overview",
        thumbnail: thumbnail_6,
        buttonText: "Download pdf",
        pdf: "/pdfs/zerto/zerto-overview 1.pdf",
      },
    ],
  },
  {
    id: 2,
    sectionTitle: "Customer stories",
    items: [
      {
        id: 1,
        title: "Customer story",
        description: "Bringing certainty to healthcare’s digital journey",
        thumbnail: thumbnail_7,
        buttonText: "Download pdf",
        pdf: "/pdfs/zerto/Bringing certainty to healthcare’s digital journey 1.pdf",
      },
      {
        id: 2,
        title: "Customer story",
        description: "Tencate and Hewlett Packard Enterprise",
        thumbnail: thumbnail_8,
        buttonText: "Download pdf",
        pdf: "/pdfs/zerto/TENCATE AND HEWLETT PACKARD ENTERPRISE.pdf",
      },
    ],
  },
  {
    id: 3,
    sectionTitle: "Ebook",
    items: [
      {
        id: 1,
        title: "Ebook",
        description: "The Need For Speed In Cyber Resilience",
        thumbnail: thumbnail_9,
        buttonText: "Download pdf",
        pdf: "/pdfs/zerto/THE NEED FOR SPEED IN CYBER RESILIENCE 1.pdf",
      },
    ],
  },
];

export const ThankYouZerto = () => {
  const [isAtTop, setIsAtTop] = useState(false);

  useEffect(() => {
    if (!isAtTop) {
      window.scrollTo({ top: 0 });
      setIsAtTop(true);
    }
  }, []);

  return (
    <ZertoLayout title="HPE Zerto Software">
      <div
        className="relative flex justify-center mb-auto h-[640px] md:mb-[96px]
       bg-thank-you-bg-zerto bg-cover px-4 lg:px-[156px] before:absolute before:inset-0 before:bg-[linear-gradient(180deg,rgba(0,0,0,0.90)_-3.27%,rgba(0,0,0,0.00)_126.14%)] before:md:bg-[linear-gradient(90deg,rgba(0,0,0,0.90)_-10.69%,rgba(0,0,0,0.18)_73.43%)] before:h-full before:w-full"
      >
        <div className="w-full max-w-[1128px] flex flex-col items-center lg:flex-row gap-12 xl:gap-[120px] pt-32 lg:pt-0">
          <div className="flex flex-col gap-2 z-10 w-full lg:max-w-[360px]">
            <img src={check} alt="check" className="w-[53.53px] h-[53.53px]" />
            <h2 className="text-white">Your download is ready.</h2>
          </div>

          <div className="w-full flex flex-col lg:flex-row items-start gap-8 bg-white px-[20px] md:px-6 py-[20px] md:py-6 z-10 rounded-md shadow-[0px_4px_40px_0px_#00000014]">
            <img
              src={thumbnail}
              alt="book"
              className="max-h-[268px] md:max-w-full lg:max-w-[100px] xl:max-w-[196px] w-full h-auto object-cover shrink"
            />

            <div className="flex flex-col gap-8 w-full min-w-0">
              <div className="flex flex-col gap-3">
                <p className="text-black b2">
                  Understanding real-time encryption detection with HPE Zerto
                  Software
                </p>
                <p className="b3 text-grey-04">
                  Technical White paper | PDF | 511 KB | 11 pages
                </p>
              </div>

              <a
                href="/pdfs/zerto/understanding-real-time-encryption-detection.pdf"
                download={true}
              >
                <Button
                  text={"Download PDF"}
                  styles="lg:flex-1 [&_svg]:!size-[20px] !gap-2 max-w-full md:max-w-[234px]"
                  Icon={FileDown}
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-center gap-10 mt-[200px] lg:mt-0 px-4 lg:px-[156px]">
        <div className="flex flex-col gap-10 w-full max-w-[1128px]">
          <div className="flex flex-col gap-6 md:flex-row md:justify-between">
            <h4 className="text-grey-07 w-full !text-[16px] md:!text-[18px]">
              Continue Exploring Zerto Software
            </h4>
            <a href="/pdfs/zerto/hpe-zerto.zip" download={true}>
              <Button
                text="Download all"
                styles="bg-transparent border border-purple-06 !text-purple-06 gap-2 md:!w-auto text-nowrap !text-[14px] [&_svg]:size-[16px] !py-2 !px-5"
                Icon={Download}
              />
            </a>
          </div>

          <div className="flex flex-col gap-10 mb-16 md:mb-20">
            {sectionsData.map((section) => (
              <div key={section.id} className="flex flex-col gap-4">
                <h4 className="text-grey-07">{section.sectionTitle}</h4>

                <div className="grid xl:grid-cols-2 grid-cols-1 gap-6">
                  {section.items.map((item) => (
                    <div
                      key={item.id}
                      className="w-full flex flex-col gap-6 p-4 rounded-3xl border border-grey-01"
                    >
                      <div className="flex gap-6">
                        <img
                          src={item.thumbnail}
                          alt="thumbnail"
                          className="w-full max-w-[120px] md:max-w-[248px] h-auto aspect-[248/170] object-cover rounded-lg"
                        />

                        <div className="flex flex-col justify-between grow">
                          <div className="flex flex-col gap-2">
                            <h4 className="text-purple-06 !text-[12px]">
                              {item.title}
                            </h4>
                            <p className="b3 text-grey-06">
                              {item.description}
                            </p>
                          </div>

                          <a
                            href={item.pdf}
                            download={true}
                            className="hidden md:block"
                          >
                            <Button
                              text={"Download PDF"}
                              styles="!b4 bg-transparent border border-purple-06 !text-purple-06 gap-2 text-nowrap !text-[14px] [&_svg]:size-[16px] !py-2 !px-5"
                              Icon={Download}
                            />
                          </a>
                        </div>
                      </div>

                      <a
                        href={item.pdf}
                        download={true}
                        className="block md:hidden"
                      >
                        <Button
                          text={"Download PDF"}
                          styles="!b4 bg-transparent border border-purple-06 !text-purple-06 gap-2 text-nowrap !text-[14px] [&_svg]:size-[16px] !py-2 !px-3"
                          Icon={Download}
                        />
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </ZertoLayout>
  );
};
